// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 通知容器样式 */

.notification-container {
  position: fixed;
  top: 2rem;
  right: 2rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 400px;
  pointer-events: none;
}

.notification {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: var(--crystal-bg);
  backdrop-filter: var(--crystal-backdrop);
  -webkit-backdrop-filter: var(--crystal-backdrop);
  border: 1px solid var(--crystal-border);
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  overflow: hidden;
  animation: slideInRight 0.3s ease;
  transition: all var(--duration-normal) ease;
}

.notification:hover {
  transform: translateX(-5px);
  box-shadow: var(--shadow-xl);
}

.notification::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.notification-success::before {
  background: var(--leaf-500);
}

.notification-error::before {
  background: #ef4444;
}

.notification-info::before {
  background: var(--lemon-500);
}

.notification-warning::before {
  background: var(--mango-500);
}

.notification-icon {
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.notification-icon i {
  font-size: 1.25rem;
}

.notification-success .notification-icon i {
  color: var(--leaf-500);
}

.notification-error .notification-icon i {
  color: #ef4444;
}

.notification-info .notification-icon i {
  color: var(--lemon-500);
}

.notification-warning .notification-icon i {
  color: var(--mango-500);
}

.notification-content {
  flex: 1;
}

.notification-title {
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}

.notification-message {
  font-size: 0.8125rem;
  color: var(--gray-600);
  line-height: 1.4;
}

.notification-close {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--gray-500);
  transition: all var(--duration-fast) ease;
  margin-top: -0.25rem;
  margin-right: -0.25rem;
}

.notification-close:hover {
  background: rgba(0, 0, 0, 0.2);
  color: var(--gray-700);
  transform: scale(1.1);
}

.notification-close i {
  font-size: 0.75rem;
}

@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .notification-container {
    right: 1rem;
    left: 1rem;
    max-width: none;
  }
  
  .notification {
    padding: 0.875rem 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NotificationContainer.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,wCAAwC;EACxC,gDAAgD;EAChD,uCAAuC;EACvC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,UAAU;AACV;EACE;IACE,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* 通知容器样式 */\n\n.notification-container {\n  position: fixed;\n  top: 2rem;\n  right: 2rem;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-width: 400px;\n  pointer-events: none;\n}\n\n.notification {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  background: var(--crystal-bg);\n  backdrop-filter: var(--crystal-backdrop);\n  -webkit-backdrop-filter: var(--crystal-backdrop);\n  border: 1px solid var(--crystal-border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-lg);\n  cursor: pointer;\n  pointer-events: auto;\n  position: relative;\n  overflow: hidden;\n  animation: slideInRight 0.3s ease;\n  transition: all var(--duration-normal) ease;\n}\n\n.notification:hover {\n  transform: translateX(-5px);\n  box-shadow: var(--shadow-xl);\n}\n\n.notification::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n}\n\n.notification-success::before {\n  background: var(--leaf-500);\n}\n\n.notification-error::before {\n  background: #ef4444;\n}\n\n.notification-info::before {\n  background: var(--lemon-500);\n}\n\n.notification-warning::before {\n  background: var(--mango-500);\n}\n\n.notification-icon {\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.notification-icon i {\n  font-size: 1.25rem;\n}\n\n.notification-success .notification-icon i {\n  color: var(--leaf-500);\n}\n\n.notification-error .notification-icon i {\n  color: #ef4444;\n}\n\n.notification-info .notification-icon i {\n  color: var(--lemon-500);\n}\n\n.notification-warning .notification-icon i {\n  color: var(--mango-500);\n}\n\n.notification-content {\n  flex: 1;\n}\n\n.notification-title {\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.25rem;\n  font-size: 0.875rem;\n}\n\n.notification-message {\n  font-size: 0.8125rem;\n  color: var(--gray-600);\n  line-height: 1.4;\n}\n\n.notification-close {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--gray-500);\n  transition: all var(--duration-fast) ease;\n  margin-top: -0.25rem;\n  margin-right: -0.25rem;\n}\n\n.notification-close:hover {\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--gray-700);\n  transform: scale(1.1);\n}\n\n.notification-close i {\n  font-size: 0.75rem;\n}\n\n@keyframes slideInRight {\n  0% {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .notification-container {\n    right: 1rem;\n    left: 1rem;\n    max-width: none;\n  }\n  \n  .notification {\n    padding: 0.875rem 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
